/*
 * @Author: cc
 * @Date: 2020-01-09 13:19:50
 * @LastEditTime: 2021-04-08 15:24:09
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\networkResource\networkResource.js
 * @Description: 网络资源模块
 */
angular
    .module('networkSourceCenterModule', [
        'networkSourceCenterRouterModule', // 路由模块
        'networkSourceCenteLeftModule', // 左侧导航模块
        'myResourcesModule', // 订阅资源模块
        'featuredResourceModule', // 特色资源模块
        'classifiedResourceModule', // 分类资源
    ])
    .controller('networkSourceCenterCtrl', ['$scope', function($scope) {
    }]);
